import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataPurchaseOrganization } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_PURCHASE_ORGANIZATION =
  defineMasterdataEntity<MasterdataPurchaseOrganization>({
    name: 'purchase-organization',
    responseKey: 'purchaseOrganizations',
    displayWith: (o) => keyName(o.key, o.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-cart-shopping',
    title: 'Einkaufsorganisationssuche',
    label: 'Einkaufsorganisation',
    placeholder: 'Einkaufsorganisation suchen...',
    columns: [
      {
        label: 'Einkaufsorganisation',
        type: 'entity',
        icon: 'fa-regular fa-cart-shopping',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Nr.', value: (e) => e.key },
      { label: 'Bezeichnung', value: (e) => e.name },
    ],
  });
